import React from 'react'

function Options() {
  return (
    <div>Options</div>
  )
}

export default Options